import {computed, createApp, ref} from 'vue';
import './assets/css/reset.css'
import './assets/css/tailwind.css'
import App from './App.vue';
import router from './router';
import axios from "axios";
import { createPinia } from 'pinia';
import { useStore } from "@/store";
import piniaPersist from 'pinia-plugin-persist'

function unauthorisedEndpoint(){
    removeSessionToken();
    emptyStore();
    router.push('/login');
}


function emptyStore() {
    const store = useStore(); 
    store.user_data = '';
}


// Function to set user session token
function setUserSession(token) {
    document.cookie = `user_session=${token}; path=/;`;
}


function translation(en, ch) {

    const userStore = useStore();
    let translation = '';

    if(userStore) {
        const currentLanguage = userStore.user_data.language;

        if (currentLanguage == 'zh_CN') {
            translation = ch;
        } else {
            translation = en;
        }
    }

    return translation;
}



// Function to get session token
function getSessionToken() {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        const [cookieName, cookieValue] = cookie.trim().split('=');
        if (cookieName === 'user_session') {
            return decodeURIComponent(cookieValue);
        }
    }
    return null;
}



// Function to remove session token
function removeSessionToken() {
    document.cookie = 'user_session' + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    emptyStore();
}

const pinia = createPinia()
pinia.use(piniaPersist)

const app = createApp(App);

// Configure global properties
app.config.globalProperties.$getSessionToken = getSessionToken;
app.config.globalProperties.$removeSessionToken = removeSessionToken;
app.config.globalProperties.$setUserSession = setUserSession;
app.config.globalProperties.$unauthorisedEndpoint = unauthorisedEndpoint;
app.config.globalProperties.$emptyStore = emptyStore;
app.config.globalProperties.$translation = translation;

app.use(pinia).use(router).mount('#app');